module.exports = __webpack_public_path__ + "static/ancubator-8ece75757161063c1703aa5b9f895445.png";